import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {getSuppliers, getSupplier, saveSupplier, updateSupplier, saveSuppliers} from "@/services/supplier";
import {Supplier, SupplierState} from "@/modules/suppliers/types";

export const state: SupplierState = {
  supplier: {
    id: "",
    id_auth: "",
    id_company: "",
    address: "",
    tax_id: "",
    email: "",
    country_code: ""
  },
  suppliers: []
}

const actions: ActionTree<SupplierState, RootState> = {
  async GET_SUPPLIERS(_, payload) {
    return await getSuppliers(payload);
  },
  async GET_SUPPLIER(_, id) {
    return await getSupplier(id);
  },
  async SAVE_SUPPLIER(_, user) {
    return await saveSupplier(user);
  },
  async SAVE_SUPPLIERS(_, suppliers) {
  return await saveSuppliers(suppliers);
},
  async UPDATE_SUPPLIER(_, supplier) {
    return await updateSupplier(supplier);
  }
}

const getters: GetterTree<SupplierState, RootState> = {
  SUPPLIERS(state): Supplier[] {
    const {suppliers} = state;
    return [...suppliers];
  },
  SUPPLIER(state): Supplier {
    const {supplier} = state;
    return {...supplier};
  }
}

const mutations: MutationTree<SupplierState> = {
  SET_SUPPLIERS(state, suppliers: Supplier[]) {
    state.suppliers = suppliers;
  },
  SET_SUPPLIER(state, supplier: Supplier) {
    state.supplier = supplier;
  },
}

export const supplier: Module<SupplierState, RootState> = {
  state,
  actions,
  mutations,
  getters
}
